import { render, staticRenderFns } from "./YesNoDialog.vue?vue&type=template&id=0c31f763&scoped=true"
import script from "./YesNoDialog.vue?vue&type=script&lang=js"
export * from "./YesNoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31f763",
  null
  
)

export default component.exports